import { render, staticRenderFns } from "./AlertManagement.vue?vue&type=template&id=be1fe2b8"
import script from "./AlertManagement.vue?vue&type=script&lang=js"
export * from "./AlertManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports